import { BaseDto } from '../base.dto';
import { CustomerDto } from '../customer.dto';
import { MembershipTypeDto } from '../membership-type';

/**
 * DTO object for creation of Brand Member.
 */
export class BrandMemberDto extends BaseDto {
  brandId: number;
  customerId: number;
  membershipTypeId: number;
  code: string;
  active: boolean;
  customer?: CustomerDto;
  membershipType?: MembershipTypeDto;
  googleWalletJwtLink?: string;
  appleWalletS3Link?: string;
}
